import React from "react";
import { ChildrenProps } from "../../../../types";

interface Props extends ChildrenProps {
    colSpan?: number;
}
export const TrialBalanceDownloadHeader: React.FC<Props> = ({
    children,
    colSpan,
}) => (
    <td
        colSpan={colSpan}
        className={
            "download-table__cell--bold download-table__cell--border-bottom download-table__cell--center"
        }
    >
        {children}
    </td>
);
